import { ChartOptions } from "chart.js";
import { useServiceCounter } from "../../../hooks/useServiceCounter";

const SERVICE_LABELS = [
  "Glovebox Inspection & Preventive Maintenance",
  "Vacuum & Inert Gas System Servicing",
  "Filter & Purification Media Replacement",
  "Seal, Gasket & O-Ring Replacement",
  "Sensor Cleaning, Calibration & Validation",
  "Customization, Upgrades & Technical Support"
];

export const horizontalBarOptions: ChartOptions<"bar"> = {
  indexAxis: 'y',
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        title: () => '',
        label: (context) => {
          const serviceName = SERVICE_LABELS[context.dataIndex];
          return `${serviceName}: ${context.parsed.x}`;
        }
      },
      displayColors: false,
      intersect: true,
      mode: 'nearest',
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      grid: {
        display: true,
        color: "rgba(0, 0, 0, 0.05)",
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        precision: 0,
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        font: {
          size: 12,
        },
      },
    },
  },
  interaction: {
    intersect: true,
    mode: 'nearest',
  },
  hover: {
    intersect: true,
    mode: 'nearest',
  },
  onHover: (event: any, chartElements: any) => {
    const canvas = event.native?.target;
    if (canvas) {
      if (chartElements && chartElements.length > 0) {
        canvas.style.cursor = 'pointer';
      } else {
        canvas.style.cursor = 'default';
      }
    }
  },
  maintainAspectRatio: false,
  responsive: true,
};
